export default __webpack_public_path__ + "static/media/google_sheets_grey.b77f7938.svg";